<script>
  import WeekStatistics from "./WeekStatistics.svelte";
  import WeekDay from "./WeekDay.svelte";
  export let firstDay;
  export let year;
  export let month;
  export let sessions;

  function getISOWeekNumber(date) {
    // Copy date object so we don't modify the original
    const newDate = new Date(date.getTime());

    // Set to nearest Thursday: current date + 4 - current day number
    newDate.setDate(newDate.getDate() + 4 - (newDate.getDay() || 7));

    // Get first day of year
    const yearStart = new Date(newDate.getFullYear(), 0, 1);

    // Calculate full weeks to nearest Thursday
    const weekNumber = Math.ceil(((newDate - yearStart) / 86400000 + 1) / 7);

    return weekNumber;
  }

  let weekNo = getISOWeekNumber(firstDay);
  let firstDayInWeek = firstDay.getDay() > 0 ? firstDay.getDay() - 1 : 6;

  function addDays(date, days) {
    const newDate = new Date(date.getTime());
    newDate.setDate(newDate.getDate() + days);
    return newDate;
  }
</script>

<div class="calendar-week">
  <div class="calendar-training-period">
    <button class="calendar-training-period__button"
      ><span class="calendar-training-period__type" /></button
    >
  </div>
  <WeekStatistics {weekNo} />
  <div class="calendar-week__number-wrap">
    <div class="calendar-week__number-sm">
      <a
        role="link"
        tabindex="0"
        class="calendar-week__load-button"
        style="cursor: pointer;"
      /><span class="calendar-week__number-text">{weekNo}</span>
    </div>
    <button class="calendar-week-overview__toggle-button"
      ><i class="calendar-week-overview__toggle-icon" /></button
    >
  </div>
  <div class="calendar-days">
    {#each Array(firstDayInWeek) as _, index (index)}
      <div class="calendar-day calendar-day--is-empty" />
    {/each}
    {#each Array(7 - firstDayInWeek) as _, index (index)}
      <WeekDay {year} {month} date={addDays(firstDay, index)} {sessions} />
    {/each}
    {#if false}
      <div class="calendar-day">
        <a role="link" tabindex="0" class="calendar-day__button"
          ><div class="calendar-focus-area calendar-focus-area--resource" />
          <div class="calendar-day__header">
            <span class="calendar-day__number">2</span>
          </div>
          <ul class="list-activities" /></a
        >
      </div>
      <div class="calendar-day">
        <a role="link" tabindex="0" class="calendar-day__button"
          ><div class="calendar-focus-area calendar-focus-area--resource" />
          <div class="calendar-day__header">
            <span class="calendar-day__number">3</span>
          </div>
          <ul class="list-activities" /></a
        >
      </div>
      <div class="calendar-day">
        <a role="link" tabindex="0" class="calendar-day__button"
          ><div class="calendar-focus-area calendar-focus-area--resource" />
          <div class="calendar-day__header">
            <span class="calendar-day__number">4</span>
          </div>
          <ul class="list-activities">
            <li class="list-activities__item list-activities__item--is-done">
              <a
                class="list-activities__link"
                href="/planer/måned/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-08-04/E1DA8828-9D6B-4D3A-B0D4-04290D890C98"
                ><i
                  class="list-activities__icon list-activities__icon--check"
                /><span class="list-activities__title"
                  ><span>Skating skills (08:45)</span></span
                ><i
                  class="list-activities__icon
                list-activities__icon--comment-0"
                /></a
              >
            </li>
            <li class="list-activities__item">
              <a
                class="list-activities__link"
                href="/planer/måned/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-08-04/B2DCF7A3-F870-4B2B-B204-EC424A2671EE"
                ><span class="list-activities__title"
                  ><span>Dans (09:45)</span></span
                ><i
                  class="list-activities__icon
                list-activities__icon--comment-0"
                /></a
              >
            </li>
            <li class="list-activities__item">
              <a
                class="list-activities__link"
                href="/planer/måned/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-08-04/EC29C6EB-D528-4283-A699-DDE0F90C5AA1"
                ><span class="list-activities__title"
                  ><span>Teknikk (12:00)</span></span
                ><i
                  class="list-activities__icon
                list-activities__icon--comment-0"
                /></a
              >
            </li>
            <li class="list-activities__item">
              <a
                class="list-activities__link"
                href="/planer/måned/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-08-04/EDA32891-FA63-45A4-9DAE-90D179990B27"
                ><span class="list-activities__title"
                  ><span>Off-ice (13:45)</span></span
                ><i
                  class="list-activities__icon
                list-activities__icon--comment-0"
                /></a
              >
            </li>
            <li class="list-activities__item">
              <a
                class="list-activities__link"
                href="/planer/måned/4490D164-509E-4CCA-B21D-B2784EE3E29C/A8882F5F-2B9C-43A2-AB65-2FC3E71303C8/2022-08-04/24D3AC9D-85DF-4AED-8F4A-30B87FAB30E1"
                ><span class="list-activities__title"
                  ><span>Spinns (16:15)</span></span
                ><i
                  class="list-activities__icon
                list-activities__icon--comment-0"
                /></a
              >
            </li>
          </ul></a
        >
      </div>
      <div class="calendar-day">
        <a role="link" tabindex="0" class="calendar-day__button"
          ><div class="calendar-focus-area calendar-focus-area--resource" />
          <div class="calendar-day__header">
            <span class="calendar-day__number">5</span>
          </div>
          <ul class="list-activities" /></a
        >
      </div>
      <div class="calendar-day calendar-day--is-weekend">
        <a role="link" tabindex="0" class="calendar-day__button"
          ><div class="calendar-focus-area calendar-focus-area--resource" />
          <div class="calendar-day__header">
            <span class="calendar-day__number">6</span>
          </div>
          <ul class="list-activities" /></a
        >
      </div>
    {/if}
  </div>
</div>
